<modal-layout-right modalTitle="{{content?.title}}">
    <div modalBody>
        <div class="ratio-3-2">
            <img class="rf"
                 [image]="content?.image">
        </div>
        <span class="h4 w-12 m-b-3 p-b-3 p-t-10 b-b"
              *iCms="'descriptionTitle' of content"></span>
        <span class="p2"
              *iCms="'description' of content; content: 'html'"></span>
    </div>
</modal-layout-right>
